export const MONCO_LOGO_SRC = "/monco-logo-black.png";
// Fraction of the page's longer side. Keeps the logo visually consistent
// across A4/A3/A1. Concrete sizes: A4 ≈ 101pt, A3 ≈ 143pt, A1 ≈ 286pt.
export const MONCO_LOGO_WIDTH_RATIO = 0.12;
// PDF points. Matches LEGEND_PAGE_MARGIN.
export const MONCO_LOGO_MARGIN = 20;
export const MONCO_URL = "https://monco.ai";
// Text used when the logo asset fails to load.
export const MONCO_FALLBACK_TEXT = "Monco.ai";
// Fallback font size as a fraction of the page's longer side. Scales with
// page so the text reads at A4 (~25pt) and at A1 (~72pt) consistently.
export const MONCO_FALLBACK_FONT_SIZE_RATIO = 0.03;
// Tailwind blue-600 (#2563eb) — matches the brand color used in the modal.
export const MONCO_FALLBACK_TEXT_COLOR: readonly [number, number, number] = [
  37, 99, 235,
];
// URL link text size as a fraction of the page's longer side. Sized as a
// small supporting caption under the logo — roughly matches the logo's
// width when rendered, so it doesn't visually compete with the brand mark.
// Concrete sizes: A4 ~10pt, A3 ~14pt, A1 ~29pt.
export const MONCO_URL_FONT_SIZE_RATIO = 0.012;
// Padding (as a fraction of the page's longer side) added around the
// brand-link content for the white background rectangle behind it, so the
// logo/text stays legible over busy floor-plan drawings. Bumped in step
// with the content ratios so the relative breathing room stays the same.
// Concrete sizes: A4 ~8pt, A3 ~12pt, A1 ~24pt.
export const MONCO_BACKGROUND_PADDING_RATIO = 0.01;
